// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side_products {
    width: 100%;
    height: 100%;
    padding: 0 25px 0 23px;
}
.side_prod_img {
    width: 100%;
}
@media (max-width: 1100px) {
    .side_prod_img > img {
        margin-top: 0;
        max-height: 150px;
        width: auto;
    }
}
.side_prod_img > img {
    margin-top: 87px;
    width: 90%;
}

div.space_between_products p {
    font-size: 12px;
    font-weight: 600;
}

.products_row {
    width: 100%;
    margin-top: 20px;
}
.side_product_container {
    width: 100%;
    padding-right: 20px;
    padding-left: 20px;
}
.space_between_products {
    width: 100%;
}
.products_progress {
    margin-top: 12px;
    width: 100%;
    height: 6px;
    background-color: #d1f0f1;
    border-radius: 5px;
    position: relative;
}
.products_progress > div {
    height: 6px;
    border-radius: 5px;
}
.progress_one {
    background-color: #1EC0A6;
}
.progress_two {
    background-color: #FFAE4E;
}
.product_hint_text {
    font-size: 13px;
    font-weight: 300;
    text-align: center;
}

.product_side_image {
    width: 20px;
}

@media (max-width: 1470px) {
    .side_product_container {
        padding-right: 10px;
        padding-left: 10px;
    }
}
@media (max-width: 1300px) {
    .side_product_container {
        font-size: 14px;
    }
    .space_between_products > p {
        padding-right: 5px;
    }
}
@media (max-width: 1050px) {
    .side_prod_img {
        display: none;
    }
    .products_row {
        max-width: 600px;
    }
}


`, "",{"version":3,"sources":["webpack://./src/Components/Content/SideProducts.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,WAAW;IACf;AACJ;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".side_products {\n    width: 100%;\n    height: 100%;\n    padding: 0 25px 0 23px;\n}\n.side_prod_img {\n    width: 100%;\n}\n@media (max-width: 1100px) {\n    .side_prod_img > img {\n        margin-top: 0;\n        max-height: 150px;\n        width: auto;\n    }\n}\n.side_prod_img > img {\n    margin-top: 87px;\n    width: 90%;\n}\n\ndiv.space_between_products p {\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.products_row {\n    width: 100%;\n    margin-top: 20px;\n}\n.side_product_container {\n    width: 100%;\n    padding-right: 20px;\n    padding-left: 20px;\n}\n.space_between_products {\n    width: 100%;\n}\n.products_progress {\n    margin-top: 12px;\n    width: 100%;\n    height: 6px;\n    background-color: #d1f0f1;\n    border-radius: 5px;\n    position: relative;\n}\n.products_progress > div {\n    height: 6px;\n    border-radius: 5px;\n}\n.progress_one {\n    background-color: #1EC0A6;\n}\n.progress_two {\n    background-color: #FFAE4E;\n}\n.product_hint_text {\n    font-size: 13px;\n    font-weight: 300;\n    text-align: center;\n}\n\n.product_side_image {\n    width: 20px;\n}\n\n@media (max-width: 1470px) {\n    .side_product_container {\n        padding-right: 10px;\n        padding-left: 10px;\n    }\n}\n@media (max-width: 1300px) {\n    .side_product_container {\n        font-size: 14px;\n    }\n    .space_between_products > p {\n        padding-right: 5px;\n    }\n}\n@media (max-width: 1050px) {\n    .side_prod_img {\n        display: none;\n    }\n    .products_row {\n        max-width: 600px;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
